<!-- 申请人信息 -->
<template>
  <div class="form-common mobile-app">
    <div v-for="(item, index) in list" :key="index" class="appinfo-box">
        <div class="typeTitle">
          <div class="typeTitle-name" > {{item.applicantCategory == '1' ? '个人' : '法人'}} </div>
          <div v-show="list.length>0 " @click="delItem(item, index)" class="el-icon-remove re-btn-del" />
        </div>
        <el-form :model="item" :rules="applicantRules"  :ref="'applicant' + index" class="search-form search-items" label-width="120px">
          <el-form-item :label="item.applicantCategory == '1' ? '姓名' : '单位名称'" prop="applicantName" class=" col1-3">
            <el-input v-model.trim="item.applicantName" class="search-input" maxlength="20" />
          </el-form-item>
           <el-form-item label="性别" v-if="item.applicantCategory == '1'" prop="gender" class=" col1-3">
            <el-select
              v-model="item.gender"
              placeholder="请选择"
              class="search-input"
            >
              <el-option
                v-for="it in optionSexType"
                :key="it.lable"
                :label="it.value"
                :value="it.lable"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="法人代表" v-if="item.applicantCategory == '2'"  prop="legalRepresentative" class=" col1-3">
            <el-input v-model.trim="item.legalRepresentative" class="search-input"  maxlength="20"/>
          </el-form-item>
           <el-form-item label="国家" v-if="item.applicantCategory == '1'" prop="country" class=" col1-3">
            <el-select v-model="item.country"  placeholder="请选择" class="search-input">
              <el-option
                v-for="at in optionCountry"
                :key="at.code"
                :label="at.name"
                :value="at.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="法人代表职务" v-if="item.applicantCategory == '2'"  prop="legalRepresentativeDuty" class=" col1-3">
            <el-input v-model.trim="item.legalRepresentativeDuty" class="search-input" maxlength="20" />
          </el-form-item>
          <el-form-item label="证件类型" :rules="[ { required: true,validator: (rule, value, callback) => checkidentificationType(rule, value, callback, item), trigger: 'change' } ,]" prop="identificationType" class=" col1-3">
            <el-select v-model="item.identificationType" @change="val => { changeIdType(val, item, index)}"  placeholder="请选择" class="search-input"
            >
              <el-option
                v-for="it in optionIDType"
                :key="it.code"
                :label="it.name"
                :value="it.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :rules="[ { required: true,validator: (rule, value, callback) => checkidentificationCard(rule, value, callback, item), trigger: 'blur' } ,]" label="证件号码" prop="identificationCard" class=" col1-3">
            <el-input  v-model.trim="item.identificationCard" class="search-input"  maxlength="20" />
          </el-form-item>
          <el-form-item prop="fileListJpg"  class="upload-identificationFile col1-3">
            <span slot="label">证件材料 (图片)</span>
            <el-upload
              class="upload-identiFile"
              action=""
              :http-request="handleUpload"
              :data="{item}"
              :before-upload="(param)=>beforeUpload(param, item)"
              :on-remove="handleRemove"
              :limit="1"
              :on-exceed="handleExceed"
              :file-list="item.fileListJpg"
              accept=".jpg,.jpeg,.png"
            >
            <div class="identiFile-btn" >选择文件</div>
          </el-upload>
          </el-form-item>
          <el-form-item label="出生日期" v-if="item.applicantCategory == '1'" prop="bornDate" class=" col1-3">
            <el-date-picker
              v-model="item.bornDate"
              type="date"
              placeholder="选择日期"
              class="search-input"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              :clearable = false
              :disabled = item.isbornDate
              >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="手机号码" prop="phone" class=" col1-3">
            <el-input v-model.trim="item.phone"  class="search-input" maxlength="20"/>
          </el-form-item>
          <el-form-item label="座机号码" prop="telephone" class=" col1-3">
            <el-input v-model.trim="item.telephone" class="search-input" maxlength="20"/>
          </el-form-item>
          <el-form-item :label="item.applicantCategory == '1' ? '居住地址' : '公司地址'" prop="addr" class=" col1-3">
            <el-input v-model.trim="item.addr" class="search-input" maxlength="100"/>
          </el-form-item>
          <el-form-item :label="item.applicantCategory == '1' ? '居住地邮编' : '公司邮编'"  prop="postcode" class=" col1-3">
            <el-input v-model.trim="item.postcode" :maxlength="6" class="search-input" />
          </el-form-item>
          <el-form-item label="文书送达地址" prop="deliveryAddr" class=" col1-3">
            <el-input v-model.trim="item.deliveryAddr" class="search-input" maxlength="100" />
          </el-form-item>
          <el-form-item label="送达地邮编" prop="deliveryPostcode" class=" col1-3">
            <el-input v-model.trim="item.deliveryPostcode" :maxlength="6" class="search-input" />
          </el-form-item>
        </el-form>
    </div>
  </div>
</template>

<script>
import Api from '@api/api'
export default {
  props: {
    applicantInfoList: {
      default: () => { return [] },
      type: Array,
      required: true
    },
    caseOrderNo: {
      type: String,
      required: true
    }
  },
  data () {
    // 定义校验规则
    var validatePhone = (rule, value, callback) => {
      if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号码'))
      } else {
        callback()
      }
    }
    var validatePostcode = (rule, value, callback) => {
      if (!/^[0-9]{6}$/.test(value)) {
        callback(new Error('请输入正确的邮编'))
      } else {
        callback()
      }
    }
    var validateApplicantName = (rule, value, callback) => {
      if ((/^(?:[\u4e00-\u9fa5·]{0,20})$/.test(value) || /(^[a-zA-Z][a-zA-Z\s]{0,20}[a-zA-Z]$)/.test(value)) && value !== '') {
        callback()
      } else {
        callback(new Error('请输入正确的名称'))
      }
    }
    return {
      list: [],
      optionIDType: [],
      optionCountry: [],
      optionSexType: [{
        value: '女',
        lable: '0'
      }, {
        value: '男',
        lable: '1'
      }],
      applicantRules: {
        fileListJpg: [{ required: true, validator: this.validateFileUrl, trigger: 'change' }],
        applicantName: [
          { required: true, validator: validateApplicantName, trigger: 'blur' }
        ],
        gender: [
          { required: true, message: '请选择性别', trigger: 'change' }
        ],
        legalRepresentative: [
          { required: true, validator: validateApplicantName, trigger: 'blur' }
        ],
        country: [
          { required: true, message: '请选择国家', trigger: 'change' }
        ],
        legalRepresentativeDuty: [
          { required: true, message: '请输入法人职务', trigger: 'blur' }
        ],
        // identificationType: [{ required: true, message: '请选择证件类型', trigger: 'change' }],
        bornDate: [
          { required: true, message: '请选择出生日期', trigger: 'change' }
        ],
        phone: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ],
        addr: [
          { required: true, message: '请输入内容', trigger: 'blur' }
        ],
        postcode: [
          { required: true, validator: validatePostcode, trigger: 'blur' }
        ],
        deliveryAddr: [
          { required: true, message: '请输入文书送达地址', trigger: 'blur' }
        ],
        deliveryPostcode: [
          { required: true, validator: validatePostcode, trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    applicantInfoList (newVal) {
      this.list = newVal
    }
  },
  created () {
    this.listDictByParentCodes()
  },
  mounted () {
    this.list = this.applicantInfoList
  },
  methods: {
    validateFileUrl (rule, value, callback) {
      if (value.length === 0) {
        callback(new Error('请上传⽂件'))
      } else {
        callback()
      }
    },
    // 证件号码校验
    checkidentificationCard (rule, value, callback, itemList) {
      if (itemList.identificationCard === '') {
        return callback(new Error('请输入证件号码'))
      } else if (itemList.identificationType === '1001001') {
        // 证件类型为身份证时
        if (/^[1-9]\d{5}(?:18|19|20)\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\d|30|31)\d{3}[\dXx]$/.test(itemList.identificationCard)) {
          // 获取出身日期
          itemList.bornDate = itemList.identificationCard.substr(6, 8).replace(/(.{4})(.{2})/, '$1-$2-')
          itemList.isbornDate = true
          callback()
        } else {
          return callback(new Error('证件号码格式错误'))
        }
      } else {
        itemList.isbornDate = false
        callback()
      }
    },
    // 证件类型
    checkidentificationType (rule, value, callback, itemList) {
      if (itemList.identificationType === '') {
        return callback(new Error('请选择证件类型'))
      } else if (itemList.identificationType === '1001001' && itemList.identificationCard !== '') {
        // 证件类型为身份证时
        if (/^[1-9]\d{5}(?:18|19|20)\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\d|30|31)\d{3}[\dXx]$/.test(itemList.identificationCard)) {
          // 获取出身日期
          itemList.bornDate = itemList.identificationCard.substr(6, 8).replace(/(.{4})(.{2})/, '$1-$2-')
          itemList.isbornDate = true
          callback()
        // } else {
        //   return callback(new Error('证件号码格式错误'))
        }
      } else {
        itemList.isbornDate = false
        callback()
      }
    },
    // 增加一个申请人
    addItem (item) {
      this.list.push(item)
    },
    // 删除一个申请人
    delItem (item, index) {
      this.list.splice(index, 1)
    },
    // 证件类型change事件
    changeIdType (val, item, index) {
      item.identificationCard = ''
    },
    // 申请人姓名 失焦
    // 身份证证件号码失焦
    // 判断用户姓名和身份证号是否匹配人口库
    async compUsers (item) {
      if(item.applicantCategory === '1') {
        if (item.applicantName && item.identificationType === '1001001' && item.identificationCard) {
          const param = [{
            name: item.applicantName,
            id: item.identificationCard
          }]
          await this.checkUsers(param)
        }
      } else if (item.applicantCategory === '2') {
        if (item.legalRepresentative && item.identificationType === '1001001' && item.identificationCard) {
          const param = [{
            name: item.legalRepresentative,
            id: item.identificationCard
          }]
          await this.checkUsers(param)
        }
      }
    },
    async checkUsers (param) {
      let res = await Api.checkUsers(param)
      res = res?.data?.data
      if (!res.code && res.result.length) {
        const str = res.result.join('、')
        this.$message.warning(str)
        return str
      } else {
        return ''
      }
    },
    // 文件上传
    // 上传文件之前的钩子
    beforeUpload (file, item) {
      // if (item.fileListJpg.length > 0) {
      //   this.$message.warning('最多上传一个文件')
      //   return false
      // }
      const isLt100MB = file.size / 1024 / 1024 < 100
      const a = file.name
      const b = ['.jpg', '.jpeg', '.png']
      const isType = b.includes(a.slice(a.lastIndexOf('.')).toLowerCase())
      if (!isLt100MB) {
        if (document.getElementsByClassName('el-message').length > 0) {
          return false
        }
        this.$message({
          message: '上传文件大小不能超过 100MB!',
          type: 'warning',
          center: true
        })
        return false
      }
      if (!isType) {
        if (document.getElementsByClassName('el-message').length > 0) {
          return false
        }
        this.$message({
          message: '上传文件格式必须为jpg、jpeg、png',
          type: 'warning',
          center: true
        })
        return false
      }
    },
    // 限制文件上传个数
    handleExceed (files, fileList) {
      this.$message.warning('当前限制选择 1 个文件')
    },
    // 自定义上传
    handleUpload (param) {
      const formData = new FormData()
      formData.append('caseOrderNo', this.caseOrderNo)
      formData.append('evidenceName', param.file.name)
      formData.append('evidence', param.file)
      formData.append('kindType', 0) // 证据材料类型（0证件照1具体行政行为材料2其他补充材料）
      formData.append('identificationApplicant', param.data.item.id)
      Api.uploadFile(formData)
        .then(data => {
          param.file.evidenceId = data.data.data
          param.file.id = param.data.item.id
          this.list.map((item, index) => {
            if (item.id === param.file.id) {
              item.fileListJpg.push(param.file)
            }
            const formName = 'applicant' + index
            if (this.$refs[formName]) {
              this.$refs[formName][0].validateField('fileListJpg')
            }
          })
        }).catch(() => {
          this.list.map(item => {
            param.file.id = param.data.item.id
            if (item.id === param.file.id) {
              item.fileListJpg = []
            }
          })
        })
    },
    // 删除文件
    handleRemove (file) {
      if (file.evidenceId) {
        Api.deleteFileById(file.evidenceId).then(res => {
          this.list.forEach((item, index) => {
            if (item.id === file.id) {
              item.fileListJpg.forEach((ite, index) => {
                if (ite.evidenceId === file.evidenceId) {
                  item.fileListJpg.splice(index, 1)
                  const formName = 'applicant' + index
                  if (this.$refs[formName]) {
                    this.$refs[formName][0].validateField('fileListJpg')
                  }
                }
              })
            }
            const formName = 'applicant' + index
            if (this.$refs[formName]) {
              this.$refs[formName][0].validateField('fileListJpg')
            }
          })
        })
      } else if (file.evidenceIdNo) {
        this.list.forEach((item, index) => {
          if (item.id === file.id) {
            item.fileListJpg.forEach((ite, index) => {
              if (ite.evidenceIdNo === file.evidenceIdNo) {
                item.fileListJpg.splice(index, 1)
                const formName = 'applicant' + index
                if (this.$refs[formName]) {
                  this.$refs[formName][0].validateField('fileListJpg')
                }
              }
            })
          }
          const formName = 'applicant' + index
          if (this.$refs[formName]) {
            this.$refs[formName][0].validateField('fileListJpg')
          }
        })
      }
    },
    // 获取类型
    listDictByParentCodes () {
      // 证件类型
      Api.listDictByParentCodes({ parentCodes: '1000,1001' }).then(res => {
        this.optionCountry = res.data.data[0].subDictList
        this.optionIDType = res.data.data[1].subDictList
        console.log(this.optionIDType)
      })
    },
    // 校验
    checkAll () {
      return new Promise((resolve, reject) => {
        let checkPass = true
        this.list.map((item, index) => {
          const formName = 'applicant' + index
          this.$refs[formName][0].validate((valid) => {
            if (valid) {
              console.log('submit!', formName)
            } else {
              checkPass = false
            }
          })
        })
        if (checkPass) {
          resolve()
        } else {
          reject(this.$message.error('请检查申请人信息'))
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>

.form-common{
  .appinfo-box{
    background: rgba(90, 137, 253, 0.02);
    box-shadow: 2px 6px 10px 0px rgba(128, 126, 189, 0.24);
    border-radius: 0px 0px 4px 4px;
    backdrop-filter: blur(20px);
    margin-top: 24px;
    .typeTitle{
      background: url('~@/assets/images/applytitle.png') no-repeat;
      width: 100%;
      height: 52px;
      background-size: 100% 100%;
      display: flex;
      justify-content: space-between;
      padding: 0 20px;
      .typeTitle-name{
        font-size: 16px;
        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
        font-weight: bold;
        color: #333333;
        line-height: 53px;
      }
      .re-btn-del{
        color: #FE3535;
        font-size: 18px;
        line-height: 39px;
        cursor: pointer;
      }
    }
    .search-form{
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding:20px 30px;
    }
  }
  // 证据材料图片
  .upload-identificationFile{
    .upload-identiFile{
      display: flex;
      background-color: rgb(223,240,253);
      border-radius: 3px;
      height: 40px;
      width: 85%;
      align-items: center;
      .identiFile-btn{
        background-color:#5A9CFF;
        height: 24px;
        width :100%;
        line-height: 23px;
        color: white;
        border-radius: 3px;
        font-size: 12px;
        margin-left: 3px;
      }
      ::v-deep .el-upload-list {
        margin-left: 5px;
        width:70%;
        overflow :hidden;
        white-space: nowrap;
        text-overflow:ellipsis
      }
      ::v-deep .el-upload-list__item:first-child{
        margin-top: 0px;
      }
      ::v-deep .el-upload--text {
        width: 100%;
      }
    }
  }
}
@media screen and (max-width: 1000px) {
  .appinfo-box {
    .col1-3 {
      width: 50%;
    }
    .search-form {
      padding: 10px !important;
    }
  }
  .upload-identiFile{
    min-height: 70px !important;
    display: block !important;
  }
  .identiFile-btn{
    width: 50% !important;
  }
}
@media screen and (max-width: 600px) {
  .main-contentBox {
    .search-form {
      padding: 20px 10px !important;
    }
    .appinfo-box {
      ::v-deep.el-form-item__label {
        width: 110px !important;
        font-size: 12px !important;
      }
      ::v-deep.el-form-item__content {
        margin-left: 110px !important;
      }
    }
  }
}

@media screen and (max-width: 450px) {
  .appinfo-box {
    .col1-3 {
      width: 100%;
    }
    ::v-deep.el-form-item__label {
      width: 120px !important;
    }
    .el-form-item {
      margin-bottom: 0;
    }
    ::v-deep .el-form-item__error {
      position: static;
    }
  }
}
</style>
